import { BaseRepository } from '../../interfaces/base-repository';
import { BaseClass } from '../base-class';

export class Federation extends BaseClass implements BaseRepository {
  federationKey: number;
  label: string;
  description: string;
  licences: Licence[];

  constructor()
  constructor(
    label: string,
    description?: string
  )
  constructor(label?: string, description?: string) {
    super();
    this.label = label;
    this.description = description;
  }

  static fromObject(object: Federation): Federation {
    return Object.assign(new Federation(), {
      ...object
    });
  }

  get display(): string {
    return this.label;
  }

  doesInclude(value: string): boolean {
    return this.some([this.label], value);
  }
}

export class Licence extends BaseClass implements BaseRepository {
  federationKey: number;
  licenceKey: number;
  label: string;
  description: string;
  price: number;

  constructor()
  constructor(
    federationKey: number,
    label: string,
    description: string,
    price: number
  )
  constructor(federationKey?: number, label?: string, description?: string, price?: any) {
    super();
    this.federationKey = federationKey;
    this.label = label;
    this.description = description;
    this.price = price;
  }

  static fromObject(object: Licence): Licence {
    return Object.assign(new Licence(), {
      ...object
    });
  }

  get display(): string {
    return this.label;
  }

  doesInclude(value: string): boolean {
    return this.some([this.label], value);
  }
}
